import { Feature, Polygon } from 'geojson';

import { DatesModel, GeoModel, CountryModel, ZonesModel } from '@/models/sidebar/info.model';
import colors from './colors';

// Resolves relation to the country by date and name
const resolveRelation = (dateCountries: CountryModel) => {
  return {
    color: parseZone(dateCountries.color),
    effect: dateCountries.effect,
    name: dateCountries.name,
    date: dateCountries.borderDate
  };
};

// Finds countries in the current date
const resolveDate = (dbDates: DatesModel[], currentDate: string) => {
  return dbDates.find(element => element.date == currentDate)?.countries;
};

// Finds country by faction
const parseZone = (zone: string) => {
  return colors[zone];
};

const parseGeoJson = (dbGeos: GeoModel[], dbDates: DatesModel[], currentDate: string): Feature<Polygon, ZonesModel>[] => {
  const countriesInDate = resolveDate(dbDates, currentDate);
  const features: Feature<Polygon, ZonesModel>[] = [];

  if (!countriesInDate) {
    return [];
  }

  // Checks if country exists in current date and if so pushes it to features
  dbGeos.forEach(relation => {
    const dateCountries = countriesInDate.find(e => (e.name === relation.country.name) && (e.borderDate === relation.date));
    if (!dateCountries) {
      return;
    }

    const parsedRelation = resolveRelation(dateCountries);

    const properties: ZonesModel = {
      id: relation?.country?.id,
      color: parsedRelation.color,
      effect: parsedRelation.effect,
      country: relation?.country?.name,
      pane: dateCountries.color,
      date: relation?.date,
    };

    const geometry: Polygon = {
      type: 'Polygon',
      coordinates: relation?.geometry?.coordinates
    };

    const feature: Feature<Polygon, ZonesModel> = {
      type: 'Feature',
      properties,
      geometry
    };

    features.push(feature);
  });

  return features;
};

export default parseGeoJson;
